import React, { useState, useContext } from 'react'
import { Container, Grid, Divider, TextField, InputAdornment, IconButton } from '@material-ui/core'
import { SkyPaper } from '../Core/Frames/SkyPaper'
import { ReactComponent as AccountSvg } from '../../assets/sidemenu/login.svg'
import './BrokerPortal.scss'
import FlexView from 'react-flexview/lib'
import { GetEmailPopup } from './Common/GetEmailPopup'
import { GetUserExtendedFilterPopup } from './Common/GetUserExtendedFilterPopup'
import { SessionContextStore } from '../../context/SessionContext'
import { useHistory } from 'react-router-dom'
import { EventEmitterService, EventKey } from '../../services/EventEmitterService'
import { FirebaseService, FirebaseConfigKey } from '../../services/FirebaseService'
import EqualizerIcon from '@material-ui/icons/Equalizer';
import ShareIcon from '@material-ui/icons/Share';
import brokerApi from '../../api/broker.api'
import { awaitWithLoading, generateProposalLink } from '../../services/utils'
import { ElevatedCircle } from '../Core/ElevatedCircle'
import { CopyToClipboard } from '../Core/Buttons/CopyToClipboardButton'
import { SessionService } from '../../services/SessionService';
import insuranceApi from '../../api/insurance.api'

export const BrokerPortalPanel = () => {
    const [popup, setPopup] = useState({open: false, title: '', body: '', showExtendedSearch: false, action: '', showDuration: false})
    const [extendedPopup, setExtendedPopup] = useState({open: false, title: '', body: '', showExtendedSearch: false, action: '', showDuration: false})
    const sessionContext = useContext(SessionContextStore)
    const history = useHistory()

    const onConfirm = async (data) => {
        if(popup.action == 'proposalProfile') {
            let res = await awaitWithLoading(brokerApi.generateProposalToken(data.email))
            if(res.ok) {
                cancelPopup()
                EventEmitterService.dispatch(EventKey.ShowSuccess, {title: 'Proposal Link',
                 icon: <ElevatedCircle> <ShareIcon className="blue" /></ElevatedCircle>,
                 body: <>
                    <div class="margin-bottom-small">Copy and paste the link below to the email you send to your client</div>
                    <TextField InputProps={{endAdornment: <InputAdornment> <CopyToClipboard text={generateProposalLink(res.data.proposal_form_token)} /> </InputAdornment>}} fullWidth variant="outlined" disabled={true} value={generateProposalLink(res.data.proposal_form_token)} />
                </>})
            }
            else
                EventEmitterService.dispatch(EventKey.ShowError, res)
        }
        else if (popup.action == 'generateUpgradeUrl'){
            let res = await awaitWithLoading(insuranceApi.generateUpgradeUrl(data.email));
            if (res.ok){
                EventEmitterService.dispatch(EventKey.ShowSuccess, {title: 'Upgrade Link', 
                    body: <>
                        <TextField InputProps={{ endAdornment: <InputAdornment> <CopyToClipboard text={res.data} /> </InputAdornment> }} fullWidth variant="outlined" disabled={true} value={res.data} />
                        </>});
            }
        }
        else {
            let res = await sessionContext.bindUserForBroker(data.email)
            if(res.ok) {
                EventEmitterService.dispatch(EventKey.USER_LOGGED_IN)
                if(extendedPopup.action == 'policyManagement') {
                    history.push('/policy-management')
                }
                else if (extendedPopup.action == 'account'){
                    history.push('/account')
                }
                else if (popup.action == 'discounts'){
                    history.push('/discounts')
                }
                else if(popup.action == 'fileAClaim') {
                    history.push('/claim')
                }
                else if(data.action == 'monthlyBind') {
                    history.push('/insurance/monthly')
                }
                else if(data.action == 'annualBind') {
                    history.push('/insurance/annual')
                }
                else if(data.action == 'fleetBind') {
                    history.push('/insurance/fleet')
                }
                else if(data.action == 'RefferedUsers') {
                    history.push('/annual')
                }
            }
            else 
                EventEmitterService.dispatch(EventKey.ShowError, res)
        }   
    } 

    const setPopupOptions = (isExtended , options) =>{
        if(isExtended){
            setExtendedPopup(options)
        }
        else{
            setPopup(options)
        }
    }

    const cancelPopup = () => setPopupOptions(false,{open: false, title: '', body: '', action: ''})
    const cancelExtendedPopup = () => setPopupOptions(true,{open: false, title: '', body: '', action: ''})
    const openDashboard = () => window.open(process.env.REACT_APP_DASHBOARD_URL, "_blank")
    const goToReports = () => history.push({ pathname: '/broker/admin/reports'});
    const goToSendBorderaux = () => history.push({ pathname: '/broker/admin/borderaux'});
    const gotoAccounts = () => history.push({ pathname: '/broker/accounts/active'});
    const gotoRefferdUsers = () => history.push({ pathname: '/broker/accounts/referredUsers'});
    const gotoRecentSubmissions = () => history.push({ pathname: '/broker/accounts/recent'});
    const gotoPolicyManagement = () => setPopupOptions(true,{open: true, title: 'Manage Insured\'s Policies', body: 'Insert the insured\'s email', showExtendedSearch: true, action: 'policyManagement'})
    const gotoDiscountManagement = () => setPopupOptions(false,{open: true, title: 'Manage Insured\'s Discounts', body: 'Insert the insured\'s email', action: 'discounts'})
    const gotoInsuredAccount = () => setPopupOptions(true,{open: true, title: 'Manage Insured\'s Account', body: 'Insert the insured\'s email', action: 'account'})
    const shareProporsalLink = () => setPopupOptions(false,{open: true, title: 'Share Proposal Link', body: 'Insert the insured\'s email', action: 'proposalProfile'})
    const bindAnnualPolicy = () => setPopupOptions(false,{open: true, title:'Quote / Bind Coverage', body: 'Insert the insured\'s email', showDuration: true, duration: "annualBind"})
    const bindMonthlyPolicy = () => setPopupOptions(false,{open: true, title:'Quote / Bind Coverage', body: 'Insert the insured\'s email', showDuration: true, duration: "monthlyBind"})
    const bindFleetPolicy = () => setPopupOptions(false,{open: true, title:'Quote / Bind Fleet Coverage', body: 'Insert the insured\'s email', showDuration: false, duration: "fleetBind"})
    const gotoFileAClaim = () => setPopupOptions(false,{open: true, title: 'File a client\'s claim', body: 'Insert the insured\'s email', action: 'fileAClaim'})
    const gotoAnnualUpgradePopup = () => setPopupOptions(false,{open: true, title: 'Generate Annual Upgrade URL', body: 'Insert email', action: 'generateUpgradeUrl'})
    const isAdmin = SessionService.isAdmin();
    return (
        <Container maxWidth="sm">
            <br />
            <div className="text-promotion black bolder textcenter margin-top-medium">Skywatch { isAdmin? "Admin" : "Broker" } Portal</div>
            <br />
            <div className="text-body black textcenter light">Hello, </div>
            <div className="text-body black bold textcenter margin-top-small margin-bottom-basic">What would you like to do?</div>
            <br />
            <Grid container spacing={4}>
            <Grid container spacing={4}>
            <Grid item xs={12} sm={12} md={6}>
            <SkyPaper>
                        <FlexView hAlignContent={'center'}>
                            <AccountSvg className="large-icon lightgrayblue-stroke-svg" />
                        </FlexView>
                        <div className="text-body lightgrayblue bold textcenter margin-top-6">Quote New Customer</div>
                        <Divider />
                        { FirebaseService.getBoolean(FirebaseConfigKey.ANNUAL_AVAILABLE) && <div onClick={bindAnnualPolicy} className="text-small textcenter black clickable">Annual Coverage</div> }
                        { FirebaseService.getBoolean(FirebaseConfigKey.MONTHLY_AVAILABLE) && <div onClick={bindMonthlyPolicy} className="text-small textcenter black clickable margin-top-small">Monthly Coverage</div> }
                        <div onClick={bindFleetPolicy} className="text-small textcenter black clickable margin-top-small">Fleet Coverage</div>
                    </SkyPaper>
            </Grid>
            <Grid item xs={12} sm={12} md={6}>
           <SkyPaper>  
                        <FlexView hAlignContent={'center'}>
                            <AccountSvg className="large-icon lightgrayblue-stroke-svg" />
                        </FlexView>
                        <div className="text-body lightgrayblue bold textcenter margin-top-6">Manage Accounts</div>
                        <Divider />
                        {
                            isAdmin? 
                                <div>
                                    <div onClick={gotoPolicyManagement} className="text-small textcenter black clickable">Manage Policies</div>
                                    <div onClick={gotoInsuredAccount} className="text-small textcenter margin-top-small black clickable">Manage Profile</div>
                                    <div onClick={gotoFileAClaim} className="text-small textcenter margin-top-small black clickable">File a Claim</div>
                                    <div onClick={gotoAnnualUpgradePopup} className="text-small textcenter margin-top-small black clickable">Generate Upgrade Link</div>
                                    <div onClick={gotoRefferdUsers} className="text-small textcenter margin-top-small black clickable">Manage Referrals</div>
                                </div>
                                    :
                                <div>
                                    <div onClick={gotoRecentSubmissions} className="text-small textcenter black clickable">Recent Submissions</div>
                                    <div onClick={gotoAccounts} className="text-small textcenter margin-top-small black clickable">Active Accounts</div>
                                </div>
                        }
                    </SkyPaper>
            </Grid>
            </Grid>
             <Grid container spacing={4}>
            <Grid item xs={12} sm={12} md={6}>
            <SkyPaper className="margin-top-medium">
                        <FlexView hAlignContent={'center'}>
                            <EqualizerIcon fontSize="large" className="large-icon lightgrayblue" />
                        </FlexView>
                        <div className="text-body lightgrayblue bold textcenter margin-top-6">Skywatch Dashboard</div>
                        <Divider />
                        <div onClick={openDashboard} className="text-small textcenter black clickable">View Dashboard</div>
                    </SkyPaper>
            </Grid>
            <Grid item xs={12} sm={12} md={6}>
           {isAdmin && <SkyPaper className="margin-top-medium">
                        <FlexView hAlignContent={'center'}>
                            <EqualizerIcon fontSize="large" className="large-icon lightgrayblue" />
                        </FlexView>
                        <div className="text-body lightgrayblue bold textcenter margin-top-6">Reports</div>
                        <Divider />
                        <div>
                            <div onClick={goToReports} className="text-small textcenter black clickable">Generate Reports</div>
                            <div onClick={goToSendBorderaux} className="text-small textcenter black clickable">Send Borderaux</div>
                        </div>
                    </SkyPaper>}
            </Grid>
            </Grid>
            {SessionService.isAdmin() && 
                    <Grid item xs={12} sm={12}>
                        <SkyPaper>
                            <FlexView hAlignContent={'center'}>
                                <AccountSvg className="large-icon lightgrayblue-stroke-svg" />
                            </FlexView>
                            <div className="text-body lightgrayblue bold textcenter margin-top-6">Admin</div>
                            <Divider />
                            <div onClick={() => history.push('/broker/admin/agencies')} className="text-small textcenter black clickable">Agencies</div>
                        </SkyPaper>
                    </Grid>
                }
            </Grid>
            <GetEmailPopup onCancel={cancelPopup} showDuration={popup.showDuration} duration={popup.duration} open={popup.open} title={popup.title} body={popup.body} onConfirm={onConfirm} showExtendedSearch={popup.showExtendedSearch} />
            <GetUserExtendedFilterPopup onCancel={cancelExtendedPopup} open={extendedPopup.open} title={extendedPopup.title} body={extendedPopup.body} onConfirm={onConfirm} />
        </Container>
    )
}